import { useAutomationsEnabled } from "#app/lib/hooks/use-automations-enabled";
import { useIsPhoneClass } from "#app/lib/hooks/use-phone-class";
import { useAutomationPermissions } from "./use-automation-permissions";

/**
 * Gate for the per-entity "Automate …" entries a workflow view offers — the
 * stage item on board column / table stage-group menus, the field item on
 * custom-field column header menus. The item components own the actions;
 * this hook only answers whether any of them may show. Gated the same way as
 * the workflow header popover — flag on + create capability — plus a
 * workflow to scope to, and hidden on a phone (the rotation-stable device
 * class the automations dialog itself gates the builder on — `useIsMobile()`
 * would re-offer the item in landscape), where the dialog has no builder to
 * land in.
 */
export function useAutomateFromView(workflowId: string | null | undefined) {
  const isPhone = useIsPhoneClass();
  const automationsEnabled = useAutomationsEnabled();
  const { canCreate } = useAutomationPermissions();
  return {
    canAutomate: !isPhone && automationsEnabled && canCreate && !!workflowId,
  } as const;
}
